/**
 * 導向處理相關的 utility functions
 */

/**
 * 檢查是否為內部連結
 * @param {string} url - 要檢查的 URL
 * @returns {boolean} 是否為內部連結
 */
export const isInternalLink = (url) => {
  if (!url) return false
  const currentDomain = window.location.origin
  return url.startsWith(currentDomain) || url.startsWith('/')
}

/**
 * 從完整 URL 中提取內部路徑
 * @param {string} url - 完整 URL
 * @returns {string} 內部路徑
 */
export const getInternalPath = (url) => {
  if (url.startsWith('/')) {
    return url
  }
  const currentDomain = window.location.origin
  return url.replace(currentDomain, '')
}

/**
 * 處理連結導向 (適用於 Vue 元件)
 * @param {Object} context - Vue 元件的 context (包含 $router)
 * @param {string} url - 目標 URL
 */
export const handleLinkNavigation = (url) => {
  if (!url) return

  if (isInternalLink(url)) {
    // 使用 Nuxt 路由進行內部導向
    const path = getInternalPath(url)
    window.$nuxt.$router.push(path)
  } else {
    // 外部連結使用新視窗開啟
    window.open(url, '_blank')
  }
}
